import React from 'react'
import './newsletter.css'
const NewsLetter = () => {
  return (
    <div className='newsletter'>
      <h1>Get Cheaper Offers On Your Email</h1>
      <p>Subscribe to our newsletter and stay updated</p>
      <div>
        <input type='email' placeholder='Your email address' />
        <button>Subscribe</button>
      </div>
    </div>
  )
}

export default NewsLetter
